import * as React from "react";
const SvgCross = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m6 6 12 12m0-12L6 18" }));
export default SvgCross;
